import { DashboardItem } from './AllDashboards.interface'

export const DASHBOARD_DATA: DashboardItem[] = [
  {
    image: true,
    link: '/cloud-insights/cloud-activity-dashboard',
    linkText: 'Cloud Activity Dashboard',
    imagelink: '/assets/images/dashboard/cloud-activity-dashboard@2x.jpg',
    description:
      'A view, delivered in near real time, of the speed and volume at which the Zscaler platform is performing.',
  },
  {
    image: true,
    link: '/cloud-insights/threat-map-dashboard',
    linkText: 'Global Threat Map Dashboard',
    imagelink: '/assets/images/dashboard/threat-map-dashboard@2x.jpg',
    description:
      'An interactive map that illustrates the threats that Zscaler has blocked during the past 24 hours using antivirus, advanced threat protection, and sandbox technology.',
  },
  {
    image: true,
    link: '/cloud-insights/global-enforcement-dashboard',
    linkText: 'Global Enforcement Dashboard',
    imagelink: '/assets/images/dashboard/global-enforcement-dashboard@2x.jpg',
    description:
      'A depiction of the hourly transactions, threats blocked, and policies enforced worldwide in the Zscaler cloud.',
  },
  {
    image: true,
    link: '/cloud-insights/global-internet-threats-insights',
    linkText: 'Global Internet Threat Insights',
    imagelink: '/assets/images/dashboard/global-internet-threats-insights@2x.jpg',
    description:
      'A graphical representation of the movement of global threats, showing countries of origin, target destinations, and threat types.      ',
  },
  {
    image: true,
    link: '/cloud-insights/global-isp-incidents',
    linkText: 'Global ISP Incidents',
    imagelink: '/assets/images/dashboard/threatlabz-ISP-insights@2x.jpg',
    description:
      'Review the health of the internet in real time. Instantly see ISP incidents mapped by severity around the world.      ',
  },
  {
    image: true,
    link: '/cloud-insights/encrypted-traffic-dashboard',
    linkText: 'Encrypted Traffic Dashboard',
    imagelink: '/assets/images/dashboard/encrypted-traffic-dashboard@2x.jpg',
    description:
      'A dashboard that shows the volume of encrypted traffic as a percentage of total traffic moving across the cloud.',
  },
  {
    image: true,
    link: '/cloud-insights/iot-dashboard',
    linkText: 'Internet of Things Dashboard',
    imagelink: '/assets/images/dashboard/iot-dashboard@2x.jpg',
    description: 'How much traffic is generated by things? More than you think.',
  },
  {
    image: true,
    link: '/cloud-insights/work-from-anywhere-dashboard',
    linkText: 'Work From Anywhere Trends',
    imagelink: '/assets/images/dashboard/work-from-anywhere-dashboard@2x.jpg',
    description: 'How has enterprise traffic changed since the beginning of the pandemic?',
  },
]
